<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editResolution') }}</h1>
      <div class="form-container">
        <ResolutionForm @save="save"
                        :edit-mode="true"
                        :resolution-data="resolutionData">
        </ResolutionForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import ResolutionForm from '@/components/ResolutionForm'

  export default {
    components: {
      ResolutionForm,
      DashboardLayout
    },
    methods: {
      save(resolutionForm) {
        this.$store.dispatch('Docflow/updateResolution', {
          ...resolutionForm,
          docType: this.$route.params.docType
        }).then(() => {
          this.$router.push({
            name: this.$route.params.docType === 'incoming' ? 'docflowIncomingDetail' : 'docflowAppealDetail',
            params: {documentId: this.$route.params.documentId}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Docflow/getRelations', {
        category: 'incoming',
        documentId: this.$route.params.documentId
      })
    },
    computed: {
      ...mapState('Docflow', ['document']),
      resolutionData() {
        return this.document ? {
          ...this.document,
          resolution_tasks: this.document.resolution_tasks.map(task => {
            return {...task, term_date: new Date(task.term_date)}
          }),
          resolution_term_date: this.document.resolution_term_date ? new Date(this.document.resolution_term_date) : null,
        } : {}
      },
      breadcrumbs() {
        return [
          {name: 'docflow'},
          {
            name: 'docflowDetail',
            path: {
              name: 'docflowIncomingDetail',
              params: {documentId: this.$route.params.documentId}
            }
          },
          {name: 'editResolution'}
        ]
      }
    }
  }
</script>
